<div class="content-wrapper">
    <div class="content-body">
        <div id="user-profile">
            <div class="row">
                <div class="col-12">
                    <button class="btn btn-icon btn-flat-primary mb-1" type="button" (click)="goBack()">
                        <i data-feather="arrow-left" class="mr-8px"></i>&nbsp;Back to Universities
                    </button>
                    <div class="card profile-header mb-2">
                        <img class="card-img-top" src="{{university?.university_cover_file?.url}}"
                             alt="{{university?.name}}"/>
                        <div class="banner-logo d-flex align-items-center">
                            <img src="{{university?.university_icon_file?.url}}"
                                 class="rounded img-fluid"
                                 alt="Card image"/>
                            <div class="profile-title ml-2">
                                <h2 class="text-white mb-0">{{university?.name}}</h2>
                                <p class="text-white mb-0">{{university?.city?.name}}, {{university?.state?.name}}</p>
                            </div>
                        </div>
                        <div class="banner-actions d-flex flex-column">
                            <button type="button" class="btn btn-primary btn-sm mb-1" title="Card Stats"
                                    (click)="openCardStatsModal(cardStatsModal)">
                                <i class="fas fa-chart-bar"></i>
                                Card Stats
                            </button>
                            <button type="button" class="btn btn-primary btn-sm mb-1" title="Campus Video"
                                    (click)="updateVideoLinkModal(videoModal)">
                                <i class="fas" [ngClass]="university && university['campus_video_url'] ? 'fa-video' : 'fa-plus'"></i>
                                Campus Video
                            </button>
                            <div class="btn-group" role="group" *ngIf="university && university['brochure_file_id']">
                                <button type="button" class="btn btn-primary btn-sm" title="Upload Brochure"
                                        (click)="brochureUpload.click()">
                                    <i class="fas fa-cloud-upload-alt"></i>
                                </button>
                                <button type="button" class="btn btn-primary btn-sm" title="Download Brochure"
                                        (click)="openUniversityBrochure()">
                                    <i class="fas fa-eye"></i>
                                </button>
                            </div>
                            <button type="button" class="btn btn-primary btn-sm" title="Upload Brochure"
                                    (click)="brochureUpload.click()"
                                    *ngIf="university && !university['brochure_file_id']">
                                <i class="fas fa-cloud-upload-alt"></i>
                                Brochure
                            </button>
                            <input class="form-control-file display-hidden" type="file"
                                   accept="application/pdf"
                                   (change)="onBrochureFileChange($event)"
                                   #brochureUpload>
                        </div>
                        <button type="button" class="campus-video-preview" *ngIf="university && university['campus_video_url']"
                                title="Play campus video"
                                (click)="openCampusVideoPreview(campusVideoPreviewModal)">
                            <img *ngIf="campusVideoThumbnailUrl" [src]="campusVideoThumbnailUrl"
                                 alt="{{university?.name}} campus video thumbnail"/>
                            <span class="play-icon"><i class="fas fa-play"></i></span>
                            <span class="caption" *ngIf="university['campus_video_source']">{{university['campus_video_source']}}</span>
                        </button>
                        <div class="profile-header-nav">
                            <nav class="navbar navbar-expand-md navbar-light justify-content-end justify-content-md-between w-100">
                                <button
                                        class="btn btn-icon navbar-toggler"
                                        type="button"
                                        data-target="#navbarSupportedContent"
                                        aria-controls="navbarSupportedContent"
                                        aria-expanded="false"
                                        aria-label="Toggle navigation"
                                        (click)="toggleMenu = !toggleMenu"
                                        rippleEffect
                                >
                                    <i data-feather="align-justify" class="font-medium-5"></i>
                                </button>
                                <div class="collapse navbar-collapse" id="navbarSupportedContent"
                                     [ngbCollapse]="toggleMenu">
                                    <div class="profile-tabs d-flex justify-content-center flex-nowrap mt-1 mt-md-0">
                                        <ul class="nav nav-pills mb-0">
                                            <li class="nav-item">
                                                <a class="nav-link font-weight-bold" routerLink="about" routerLinkActive="active">
                                                    <span class="d-none d-md-block">About</span>
                                                    <i data-feather="info" class="d-block d-md-none"></i>
                                                </a>
                                            </li>
                                            <li class="nav-item">
                                                <a class="nav-link font-weight-bold" routerLink="key-highlights" routerLinkActive="active">
                                                    <span class="d-none d-md-block">Key Highlights</span>
                                                    <i data-feather="star" class="d-block d-md-none"></i>
                                                </a>
                                            </li>
                                            <li class="nav-item">
                                                <a class="nav-link font-weight-bold" routerLink="courses" routerLinkActive="active">
                                                    <span class="d-none d-md-block">Courses</span>
                                                    <i data-feather="book-open" class="d-block d-md-none"></i>
                                                </a>
                                            </li>
                                            <li class="nav-item">
                                                <a class="nav-link font-weight-bold" routerLink="popular-courses" routerLinkActive="active">
                                                    <span class="d-none d-md-block">Popular Courses</span>
                                                    <i data-feather="link" class="d-block d-md-none"></i>
                                                </a>
                                            </li>
                                            <li class="nav-item">
                                                <a class="nav-link font-weight-bold" routerLink="important-dates" routerLinkActive="active">
                                                    <span class="d-none d-md-block">Important Dates</span>
                                                    <i data-feather="calendar" class="d-block d-md-none"></i>
                                                </a>
                                            </li>
                                            <li class="nav-item">
                                                <a class="nav-link font-weight-bold" routerLink="ranking" routerLinkActive="active">
                                                    <span class="d-none d-md-block">Ranking</span>
                                                    <i data-feather="award" class="d-block d-md-none"></i>
                                                </a>
                                            </li>
                                            <li class="nav-item">
                                                <a class="nav-link font-weight-bold" routerLink="emi-loan-details" routerLinkActive="active">
                                                    <span class="d-none d-md-block">EMI/Loan Details</span>
                                                    <i data-feather="credit-card" class="d-block d-md-none"></i>
                                                </a>
                                            </li>
                                            <li class="nav-item">
                                                <a class="nav-link font-weight-bold" routerLink="admission-process" routerLinkActive="active">
                                                    <span class="d-none d-md-block">Admission Process</span>
                                                    <i data-feather="clipboard" class="d-block d-md-none"></i>
                                                </a>
                                            </li>
                                            <li class="nav-item">
                                                <a class="nav-link font-weight-bold" routerLink="placement" routerLinkActive="active">
                                                    <span class="d-none d-md-block">Placement</span>
                                                    <i data-feather="briefcase" class="d-block d-md-none"></i>
                                                </a>
                                            </li>
                                            <li class="nav-item">
                                                <a class="nav-link font-weight-bold" routerLink="why-choose" routerLinkActive="active">
                                                    <span class="d-none d-md-block">Why Choose</span>
                                                    <i data-feather="list" class="d-block d-md-none"></i>
                                                </a>
                                            </li>
                                            <li class="nav-item">
                                                <a class="nav-link font-weight-bold" routerLink="career" routerLinkActive="active">
                                                    <span class="d-none d-md-block">Career</span>
                                                    <i data-feather="trending-up" class="d-block d-md-none"></i>
                                                </a>
                                            </li>
                                            <li class="nav-item">
                                                <a class="nav-link font-weight-bold" routerLink="success-stories" routerLinkActive="active">
                                                    <span class="d-none d-md-block">Success Stories</span>
                                                    <i data-feather="heart" class="d-block d-md-none"></i>
                                                </a>
                                            </li>
                                            <li class="nav-item">
                                                <a class="nav-link font-weight-bold" routerLink="faq" routerLinkActive="active">
                                                    <span class="d-none d-md-block">FAQ</span>
                                                    <i data-feather="help-circle" class="d-block d-md-none"></i>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

            <router-outlet></router-outlet>
        </div>
    </div>
</div>

<ng-template #cardStatsModal>
    <div id="modal">
        <div class="modal-header font-weight-bold">
            <h4 class="modal-title font-weight-bold">Card Stats</h4>
            <i class="fas fa-times-circle pull-right text-danger cross-icon cursor-pointer"
               (click)="this.modalService.dismissAll('')"></i>
        </div>
        <div class="modal-body">
            <app-university-stat [universityId]="universityId" (saved)="this.modalService.dismissAll('')"></app-university-stat>
        </div>
    </div>
</ng-template>

<ng-template #videoModal>
    <div id="modal">
        <div class="modal-header font-weight-bold">
            <h4 class="modal-title font-weight-bold">Campus Highlights Video</h4>
            <i class="fas fa-times-circle pull-right text-danger cross-icon cursor-pointer"
               (click)="this.modalService.dismissAll('')"></i>
        </div>
        <div class="modal-body">
            <div class="row">
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <form class="form" novalidate [formGroup]="updateVideoLinkForm">
                        <div class="px-3 container">
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="campus_video_url">YouTube Video URL or Video ID</label>
                                        <input class="form-control" id="campus_video_url" type="text"
                                               placeholder="e.g. https://youtube.com/watch?v=... or just the video ID"
                                               formControlName="campus_video_url">
                                        <small *ngIf="submitted && updateVideoLinkForm.get('campus_video_url').errors?.pattern"
                                               class="text-danger">
                                            Please enter a valid YouTube URL or video ID.
                                        </small>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="campus_video_source">YouTube Channel Name</label>
                                        <input class="form-control" id="campus_video_source" type="text"
                                               placeholder="e.g. University Official Channel"
                                               formControlName="campus_video_source">
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="campus_video_thumbnail">Video Thumbnail</label>
                                        <input class="form-control" id="campus_video_thumbnail" type="file" accept="image/*"
                                               (change)="onCampusThumbnailSelected($event)">
                                        <small *ngIf="uploadingCampusThumbnail">Uploading...</small>
                                    </div>
                                    <img *ngIf="campusThumbnailPreviewUrl" [src]="campusThumbnailPreviewUrl"
                                         class="img-fluid rounded" style="max-height: 120px" alt="Thumbnail preview"/>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button class="btn btn-success color-white pull-right" [disabled]="submitting"
                    (click)="updateVideoLink()">
                <i class="fas fa-pen-square mr-1" *ngIf="!submitting"></i>
                <i class="fas fa-spinner fa-pulse mr-1" *ngIf="submitting"></i>Update
            </button>
        </div>
    </div>
</ng-template>

<ng-template #campusVideoPreviewModal>
    <div id="modal">
        <div class="modal-header font-weight-bold">
            <h4 class="modal-title font-weight-bold">{{university?.campus_video_source || 'Campus Video'}}</h4>
            <i class="fas fa-times-circle pull-right text-danger cross-icon cursor-pointer"
               (click)="this.modalService.dismissAll('')"></i>
        </div>
        <div class="modal-body p-0">
            <div class="embed-responsive embed-responsive-16by9">
                <iframe class="embed-responsive-item" [src]="campusVideoEmbedUrl" allowfullscreen></iframe>
            </div>
        </div>
    </div>
</ng-template>
